import type { ComponentDefinition } from '../factory';

export const calendarBadgeDefinition = {
  base: 'relative z-10 flex flex-col items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white text-slate-700 shadow-sm dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100',
  variants: {
    size: {
      compact: 'h-12 w-12',
    },
  },
  defaultVariants: {
    size: 'compact',
  },
  slots: {
    topBar: {
      base: 'absolute left-0 top-0 h-2 w-full bg-slate-200 dark:bg-slate-800',
    },
    day: {
      base: 'mt-1 text-base font-semibold leading-none',
    },
    month: {
      base: 'text-[10px] font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-300',
    },
  },
} satisfies ComponentDefinition;

export type CalendarBadgeSize = keyof typeof calendarBadgeDefinition.variants.size;
